import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Components
import Navigation from './components/Navigation';
import Footer from './components/Footer';

// Pages
import Home from './Pages/Home';
import About from './Pages/About';
import Services from './Pages/Services';
import Process from './Pages/Process';
import Pricing from './Pages/Pricing';
import WhyDecodia from './Pages/WhyDecodia';
import Blog from './Pages/Blog';
import Contact from './Pages/Contact';
import Consultation from './Pages/Consultation';
import PrivacyPolicy from './Pages/PrivacyPolicy'; 

// Global CSS
import './App.css';


function App() {
  return (
    <Provider store={store}>
        <CssBaseline />
        <Router>
          <div className="app-container">
            {/* <Navigation /> */}
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/process" element={<Process />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/why" element={<WhyDecodia />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/consultation" element={<Consultation />} />
                <Route path="/free-consultation" element={<Consultation />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />  
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
    </Provider>
  );
}

export default App;